import type {SVGProps} from 'react';
import * as React from 'react';

export const EierskifteIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.8}
			d="M12.75 15.948v5.8a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5v-5.8m-10.5 1.312 4.518-3.953a2.249 2.249 0 0 1 2.964 0l4.518 3.953m-12.695-6.372A5.251 5.251 0 0 0 .75 13.5v2.25H3l.75 7.5h4.5l.323-3.232M20.4 9a4.5 4.5 0 0 0-7.285-.71m5.635 14.96h-3v-3a1.5 1.5 0 1 1 3 0v3ZM3 3.75a3 3 0 1 0 6 0 3 3 0 0 0-6 0Zm10.875-.375a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 0 0-5.25 0Z"
		/>
	</svg>
);
